import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { ServiceError, useError } from 'Src/network/useError';

import service, { DayPartGetAllResponse, serviceKey } from './dayPartService';

const queryKeys = {
  getAll: () => [serviceKey.getAll],
};

const useDayPartQuery = <T = DayPartGetAllResponse>(select?: (data?: DayPartGetAllResponse | undefined) => T) => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('dayparts.errors.getAll') });
  return useQuery<DayPartGetAllResponse, ServiceError, T>({
    gcTime: Infinity,
    staleTime: Infinity,
    queryKey: queryKeys.getAll(),
    queryFn: async () => {
      try {
        return await service.getAll();
      } catch (e) {
        throw parseError(e);
      }
    },
    select,
  });
};

const useDayPart = {
  query: {
    getAll: useDayPartQuery,
  },
  mutate: {
    // TODO: include messaging for DayPart to mutate based on messages from socket
  },
};

export { useDayPart };

